import React, { useEffect, useState } from "react";
import { api } from "@/api/client.js";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function NotificationsPage() {
  const { ui } = useOrignalUi();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api("/api/notifications").then((d) => setItems(d.items)).catch(() => {});
  }, []);
  return (
    <main className="og-page" data-testid="page-notifications">
      <h1>{ui.notifications.title}</h1>
      <p className="og-lead">{ui.notifications.subtitle}</p>
      {items.length === 0 ? <p>{ui.notifications.empty}</p> : null}
      <ul className="og-list">
        {items.map((n) => (
          <li key={n.id}><strong>{n.title}</strong> {n.body}</li>
        ))}
      </ul>
    </main>
  );
}
